<template>
  <section>
      <section class="rgBox">
        <div class="rgs rgs1">
          <img src="../../assets/images/c29.png" />
          <div class="rgTip2 fhc animated fadeInRight">{{companys.telphone}}</div>
        </div>
        <div class="rgs rgs2">
          <img src="../../assets/images/c34.png" />
          <div class="rgTip animated fadeInRight">
            <img src="../../assets/images/c0.png" />
          </div>
        </div>
        <div class="rgs" @click="closeFade()">
          <img src="../../assets/images/c31.png" />
        </div>
        <div class="rgs" @click="goTop()">
          <img src="../../assets/images/c32.png" />
        </div>
      </section>

      <section class="chatfade chatshow" v-show="chatFade">
        <div class="chatcontent fwc">
          <p>欢迎来到冰谷数字科技官网，有什么问题可以随时咨询哦！</p>
          <img src="../../assets/images/c15.png" @click="closeFade()" />
        </div>
        <div class="chataction fws">
          <input
            type="text"
            placeholder="您可以直接在这里和我们联系"
            v-model="chatMsg"
            @keyup.enter="upChat()"
            value
          />
          <div class="chatbtn" @click="upChat()">发 送</div>
        </div>
      </section>

  </section>

</template>
<script>
import { mapMutations, mapGetters } from "vuex";
import { Toast } from "mint-ui";
import _ from "lodash";
export default {
  data() {
    return {
      imgPath: "../../assets/images/c1.png",
      chatFade: false,
      chatMsg: "",
    };
  },
  props: {
    //选中

  },
  methods: {
    loadDom() {
      //console.log(this.companys);
    },
    closeFade() {
      this.chatFade = !this.chatFade;
    },
    upChat(event) {
      this.$axios
        .leaveMessage({
          params: {
            message: this.chatMsg
          }
        })
        .then(res => {
          if (res.data.status === 200) {
            this.chatMsg = "";
            Toast({
              message: "提交成功",
              position: "top",
              duration: 1800
            });
          } else {
            Toast({
              message: "提交失败",
              position: "top",
              duration: 1800
            });
          }
        });
    },
    goTop() {
      $(".pageScroll").animate({ scrollTop: 0 }, 600);
    },
    go(index) {
      this.$router.replace({
        path: this.pages[index].path
      });
    }
  },
  watch: {
    chatMsg(nv, ov) {
      this.chatMsg = nv;
    }
  },
  components: {},
  created() {},
  mounted() {
    this.loadDom();
  },
  computed: {
    ...mapGetters(["companys"])
  }
};
</script>
<style lang="less" scoped>
@import "../../assets/css/reset/reset.css";
@import "../../assets/css/reset/common.less";
@import "../../assets/css/fonts/iconfont.css";
@import "../../assets/css/home.css";
@import "../../assets/css/hover.css";


@chatFadeWidth2: 400px;
@chatFadeHeight2: 210px;
@chatFadeWidth: 200px;
@chatFadeHeight: 105px;
.chatfade {
  top: calc(~"50% - @{chatFadeHeight}");
  left: 0%;
  animation: chatAnime 10s linear;
  animation-iteration-count: infinite;
  -webkit-animation-iteration-count: infinite;
}

.chatfade:hover {
  animation-play-state: paused;
  -webkit-animation-play-state: paused;
}

@keyframes chatAnime {
  0% {
    left: 0%;
    top: calc(~"50% - @{chatFadeHeight}");
  }

  20% {
    left: calc(~"50% - @{chatFadeWidth}");
    top: calc(~"100% - @{chatFadeHeight2}");
  }

  40% {
    left: calc(~"100% - @{chatFadeWidth2}");
    top: calc(~"50% - @{chatFadeHeight}");
  }

  80% {
    left: calc(~"50% - @{chatFadeWidth}");
    top: @headerHeight;
  }

  100% {
    left: 0%;
    top: calc(~"50% - @{chatFadeHeight}");
  }
}
</style>



// WEBPACK FOOTER //
// Chater.vue?cdba7072